export default __webpack_public_path__ + "static/media/spin-outer.b9eba14d.png";